import { commonCbEnv } from "./env.cb.common";

const env: Partial<typeof commonCbEnv> = {
  production: true,
  page: 'incomeaccelerator',
  meta: {
    siteTitle: 'Caruta cu bani - Income Accelerator',
    ogSiteName: 'Caruta Cu Bani',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://carutacubani.ro/cursuri/income-accelerator/',
    ogImage: 'https://carutacubani.ro/cursuri/income-accelerator/assets/images/incomeaccelerator/cover-fb.png'
  }
};

export const environment = { ...commonCbEnv, ...env };
